import { getInitialStateFromConfig } from "helpers/form";

const config = {
    email: {
        label: "Эл. почта",
        inputProps: { name: "email" },
    },
    emailConfirmed: {
        label: "Эл. почта подтверждена",
        type: "checkbox",
        inputProps: { name: "emailConfirmed" },
    },
    firstName: {
        label: "Имя",
        nullable: true,
        inputProps: { name: "firstName" },
    },
    lastName: {
        label: "Фамилия",
        nullable: true,
        inputProps: { name: "lastName" },
    },
    patronymic: {
        label: "Отчество",
        nullable: true,
        inputProps: { name: "patronymic" },
    },
    password: {
        label: "Пароль",
        inputProps: { name: "password", type: "password" },
    },
    phoneNumber: {
        // field
        label: "Телефон",
        type: "phone",
        nullable: true,
        inputProps: { name: "phoneNumber" },
    },
    phoneNumberExtension: {
        // field
        label: "Добавочный номер",
        nullable: true,
        inputProps: { name: "phoneNumberExtension" },
    },
    id: {},
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
